// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/common/governance/v0/common.proto (package squareup.governance.v0, syntax proto2)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/common/governance/v0/common.proto.
 */
export const file_squareup_common_governance_v0_common: GenFile = /*@__PURE__*/
  fileDesc("CipzcXVhcmV1cC9jb21tb24vZ292ZXJuYW5jZS92MC9jb21tb24ucHJvdG8SFnNxdWFyZXVwLmdvdmVybmFuY2UudjAiOQoGQ29tbW9uIi8KDFNlbWFudGljVHlwZRILCgdVTktOT1dOEAASEgoOTk9UX0lOX1JVQlJJQ1MQAUIqCihjb20uc3F1YXJldXAucHJvdG9zLmNvbW1vbi5nb3Zlcm5hbmNlLnYw");

/**
 * @generated from message squareup.governance.v0.Common
 */
export type Common = Message<"squareup.governance.v0.Common"> & {
};

/**
 * Describes the message squareup.governance.v0.Common.
 * Use `create(CommonSchema)` to create a new message.
 */
export const CommonSchema: GenMessage<Common> = /*@__PURE__*/
  messageDesc(file_squareup_common_governance_v0_common, 0);

/**
 * @generated from enum squareup.governance.v0.Common.SemanticType
 */
export enum Common_SemanticType {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: NOT_IN_RUBRICS = 1;
   */
  NOT_IN_RUBRICS = 1,
}

/**
 * Describes the enum squareup.governance.v0.Common.SemanticType.
 */
export const Common_SemanticTypeSchema: GenEnum<Common_SemanticType> = /*@__PURE__*/
  enumDesc(file_squareup_common_governance_v0_common, 0, 0);

